import { type AnyChainflipAsset, type ChainflipAsset } from '@chainflip/utils/chainflip';
import {
  type AnyChainData,
  type AnyChainflipChainData,
  type ChainData,
  type ChainflipChainData,
} from '@/shared/assets/chains';
import { NATIVE_TOKEN_ADDRESS } from '@/shared/assets/tokens/constants';
import mainnet from '@/shared/assets/tokens/mainnet';
import testnet from '@/shared/assets/tokens/testnet';
import { isTestnet } from '@/shared/featureFlags';

export interface Token {
  chain: AnyChainData;
  address: string;
  name: string;
  symbol: string;
  /** the symbol from the deployed contract */
  canonicalSymbol?: string;
  decimals: number;
  logo?: string;
  chainflipId?: AnyChainflipAsset;
  assetAndChainName: string; // used for display purposes, e.g. "arbUSDC"
}

export interface AnyChainflipToken extends Token {
  chain: AnyChainflipChainData;
  chainflipId: AnyChainflipAsset;
  isStablecoin: boolean;
}

export interface ChainflipToken extends Token {
  chain: ChainflipChainData;
  chainflipId: ChainflipAsset;
  isStablecoin: boolean;
}

export function isChainflipTokenOrChain(token: Token | undefined): token is ChainflipToken;
export function isChainflipTokenOrChain(chain: ChainData | undefined): chain is ChainflipChainData;
export function isChainflipTokenOrChain(obj: Token | ChainData | undefined) {
  if (!obj) return false;
  return 'chainflipId' in obj;
}

const tokens = isTestnet ? testnet : mainnet;
export type SupportedTokenSymbol = (typeof tokens)[number]['symbol'];

export * from '@/shared/assets/tokens/mainnet';
export * from '@/shared/assets/tokens/testnet';

export const isWatchable = (token: Token) =>
  token.chain.id.startsWith('evm-') && token.address !== NATIVE_TOKEN_ADDRESS;
